import type { SortingState } from '@tanstack/react-table'

import type { PaginationState } from '@/shared/components/data-table'

/** Meta de paginação do Laravel (envelope `{data, meta, links}`). */
export interface PaginatedMeta {
  current_page: number
  last_page: number
  per_page?: number
  total: number
}

export function toPagination(meta: PaginatedMeta | undefined): PaginationState | undefined {
  return meta
    ? {
        page: meta.current_page,
        pageCount: meta.last_page,
        total: meta.total,
        ...(meta.per_page ? { perPage: meta.per_page } : {}),
      }
    : undefined
}

/** Ordenação da tabela → parâmetro `sort` do spatie/laravel-query-builder ("name", "-name"). */
export function sortingToParam(sorting: SortingState): string | undefined {
  const [first] = sorting

  return first ? `${first.desc ? '-' : ''}${first.id}` : undefined
}

/** Parâmetro `sort` → ordenação da tabela. */
export function paramToSorting(sort: string | undefined): SortingState {
  if (!sort) return []

  return sort.startsWith('-') ? [{ id: sort.slice(1), desc: true }] : [{ id: sort, desc: false }]
}

/** Remove chaves vazias dos parâmetros de consulta (evita `filter[x]=` na URL). */
export function compactQuery<T extends Record<string, unknown>>(query: T): Partial<T> {
  return Object.fromEntries(
    Object.entries(query).filter(([, value]) => value !== undefined && value !== null && value !== ''),
  ) as Partial<T>
}
